import {useQueries} from "@tanstack/react-query";
import ocrIndicatorService from "../../../../services/web/ocr-indicator-service.js";
import alarmListService from "../../../../services/reports/alarm-list-service.js";

const UseFetchOptions = () => {

    const queries = useQueries({
        queries: [
            {
                queryKey: ['lane'],
                queryFn: () => ocrIndicatorService.getAllToSelect(),
                initialData: []
            },
            {
                queryKey: ['source'],
                queryFn: () => alarmListService.sources(),
                initialData: []
            }
        ]
    });

    return {
        laneOptions: queries[0].data,
        sourceOptions: queries[1].data
    };
};

export default UseFetchOptions;